/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Availability_Status_Enum =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

export type PackagingsByBarcodeQueryVariables = Exact<{
  barcode: string;
}>;


export type PackagingsByBarcodeQuery = { packaging: Array<{ id: string, sku: number, base_unit: { availability: Types.Availability_Status_Enum }, product: { name: string }, company: { id: string } }> };


export const PackagingsByBarcodeDocument = /*#__PURE__*/ gql`
    query PackagingsByBarcode($barcode: String!) {
  packaging(where: {base_unit: {gtin: {_eq: $barcode}}}) {
    id
    sku
    base_unit {
      availability
    }
    product {
      name
    }
    company {
      id
    }
  }
}
    `;

/**
 * __usePackagingsByBarcodeQuery__
 *
 * To run a query within a React component, call `usePackagingsByBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingsByBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingsByBarcodeQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function usePackagingsByBarcodeQuery(baseOptions: Apollo.QueryHookOptions<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables> & ({ variables: PackagingsByBarcodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>(PackagingsByBarcodeDocument, options);
      }
export function usePackagingsByBarcodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>(PackagingsByBarcodeDocument, options);
        }
// @ts-ignore
export function usePackagingsByBarcodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>;
export function usePackagingsByBarcodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingsByBarcodeQuery | undefined, PackagingsByBarcodeQueryVariables>;
export function usePackagingsByBarcodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>(PackagingsByBarcodeDocument, options);
        }
export type PackagingsByBarcodeQueryHookResult = ReturnType<typeof usePackagingsByBarcodeQuery>;
export type PackagingsByBarcodeLazyQueryHookResult = ReturnType<typeof usePackagingsByBarcodeLazyQuery>;
export type PackagingsByBarcodeSuspenseQueryHookResult = ReturnType<typeof usePackagingsByBarcodeSuspenseQuery>;
export type PackagingsByBarcodeQueryResult = Apollo.QueryResult<PackagingsByBarcodeQuery, PackagingsByBarcodeQueryVariables>;